export * from './bereichs-list.component';
export * from './bereichs-list.component.module';